import { CanvasBG } from './bg/canvas';
import Image from './components/image';
import Projects from './components/projects';
import Waveform from './components/waveform';
import './index.css';
import Container from './util/container';

export function App() {
  return (
    <main className="page">
      <section className="hero" aria-label="Introduction">
        <header className="page-header">
          <h2>Sankarsh M</h2>
        </header>
        <CanvasBG />

        <div className="hero-content">
          <Container>
            <div className="bio">
              <div className="portrait">
                <Image src="/me.webp" width={150} caption="me.png" />
              </div>
              <div className="">
                <p className="w-auto mb-3">
                  Hi, my name is Sankarsh. Welcome to my website!{' '}
                </p>
                <p className="w-auto">
                  I studied{' '}
                  <span className="text-yellow-500">
                    Mathematics and Computer Science
                  </span>{' '}
                  at the University of Bristol and I'm currently working as a
                  software engineer in London. I made this website to showcase
                  some of my personal projects that I work on in my free time
                  (my professional experience is on my{' '}
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/in/sankarshm/"
                  >
                    LinkedIn
                  </a>
                  ).
                </p>
                <p className="w-auto mt-3">
                  You can also find me on{' '}
                  <a target="_blank" href="https://github.com/Sank6">
                    GitHub
                  </a>
                  .
                </p>
              </div>
            </div>
          </Container>
          <Container>
            <Waveform />
          </Container>
        </div>
      </section>

      <h2 className="projects-heading">Projects</h2>
      <Projects />
    </main>
  );
}

export default App;
